import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../assets/fonts/fonts.css';

import Arise4uBlackLogo from '../../assets/images/arise logo-01 1.svg';
import PayNowModal from '../popupmodels/PayNowModal';


const PaymentFailure = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const query = new URLSearchParams(location.search);
  const txnid = query.get('txnid') || '-';
  const status = query.get('status') || '-';
  const error = query.get('error') || 'Payment Failed';

   const studentId = localStorage.getItem('registerId') || null; // Retrieve studentId from query
  const [showPayNowModal, setShowPayNowModal] = useState(false);

  const handleTryAgain = () => {
    if (!studentId) {
      // If studentId is not available, redirect to registration
      navigate('/register');
      return;
    }
    setShowPayNowModal(true); // Open PayNowModal
  };

  const handleModalClose = () => {
    setShowPayNowModal(false);
  };

  console.log("queyryr", query)

//   const handleTryAgain = () => {
//     navigate('/payment'); // Adjust to your payment initiation route
//   };

  return (
    <div className="container d-flex flex-column align-items-center justify-content-center vh-100">
      <div className="text-center mb-4">
        <img src={Arise4uBlackLogo} alt="Arise4u Black Logo" className="mb-3" style={{ width: '150px' }} />
        <h2 className="font-bold fs-1 text-danger">Payment Failed</h2>
        <p className="font-regular fs-4">Unfortunately, your payment could not be processed. Please try again.</p>
      </div>
      <div className="card p-4 shadow" style={{ maxWidth: '900px', width: '100%' }}>
        <h4 className="font-bold fs-5">Transaction Details</h4>
        <p className="mb-2"><strong>Transaction ID:</strong> {txnid}</p>
        <p className="mb-2"><strong>Status:</strong> {status}</p>
        <p className="mb-2"><strong>Error:</strong> {error}</p>
      </div>
      <button
        className="btn btn-warning mt-4 font-regular-four fs-5"
        onClick={handleTryAgain}
      >
        Try Again
      </button>

     {showPayNowModal && (
        <PayNowModal
          id="modal-paynow"
          show={showPayNowModal}
          studentId={studentId}
          onClose={handleModalClose}
        />
      )}
    </div>
  );
};

export default PaymentFailure;